import type { Application } from '@domain/entities';
import type { IApplicationRepository } from '@domain/repositories';
import type {
  ApplicationPayload,
  PaginatedResult,
  PaginationParams,
} from '@application/dto';
import type { IHttpClient } from '@application/ports';
import { API_ENDPOINTS } from '@infrastructure/config';

export class ApplicationRepository implements IApplicationRepository {
  constructor(private readonly httpClient: IHttpClient) {}

  async list(params: PaginationParams): Promise<PaginatedResult<Application>> {
    const response = await this.httpClient.get<PaginatedResult<Application>>(
      API_ENDPOINTS.applications.base,
      {
        params: {
          page: params.page,
          limit: params.limit,
          ...(params.search ? { search: params.search } : {}),
        },
      }
    );

    return response.data;
  }

  async create(payload: ApplicationPayload): Promise<Application> {
    const response = await this.httpClient.post<Application>(
      API_ENDPOINTS.applications.base,
      payload
    );
    return response.data;
  }

  async update(id: string, payload: Partial<ApplicationPayload>): Promise<Application> {
    const response = await this.httpClient.patch<Application>(
      API_ENDPOINTS.applications.byId(id),
      payload
    );
    return response.data;
  }

  async activate(id: string): Promise<Application> {
    const response = await this.httpClient.patch<Application>(
      API_ENDPOINTS.applications.activate(id)
    );
    return response.data;
  }

  async deactivate(id: string): Promise<Application> {
    const response = await this.httpClient.patch<Application>(
      API_ENDPOINTS.applications.deactivate(id)
    );
    return response.data;
  }
}
